/* Home port (concept 1-on-1): header arrows of a product list drive that section's Horizon carousel. */
import { register } from '@qt/core';

register('[data-qt-list-nav]', {
  init(root) {
    const slideshow = root.closest('.shopify-section')?.querySelector('slideshow-component');
    if (!slideshow) return;
    root.querySelectorAll('[data-qt-list-step]').forEach((button) => {
      button.hidden = false;
      button.onclick = () => (button.dataset.qtListStep < 0 ? slideshow.previous() : slideshow.next());
    });
  },
});
